import { render, staticRenderFns } from "./ExcursionCard.vue?vue&type=template&id=f8c1aa02&scoped=true"
import script from "./ExcursionCard.vue?vue&type=script&lang=ts"
export * from "./ExcursionCard.vue?vue&type=script&lang=ts"
import style0 from "./ExcursionCard.vue?vue&type=style&index=0&id=f8c1aa02&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c1aa02",
  null
  
)

export default component.exports